import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping, faChair } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../../../../components/Button';
import classes from './kiosk-order-type-screen.module.scss';

type KioskOrderTypeScreenProps = {
  isOpening: boolean;
  onDineIn: () => void;
  onTakeAway: () => void;
};

export const KioskOrderTypeScreen: React.FC<KioskOrderTypeScreenProps> = ({
  isOpening,
  onDineIn,
  onTakeAway,
}) => (
  <section className={classes.screen} dir="rtl" data-testid="kiosk-order-type-screen" aria-label="סוג הזמנה">
    <div className={classes.actions}>
      <Button
        variant="save"
        className={`${classes.action} ${classes.dineIn}`}
        disabled={isOpening}
        onClick={onDineIn}
        dataTestId="kiosk-order-dine-in"
      >
        <FontAwesomeIcon icon={faChair as IconProp} className={classes.icon} />
        <span>לשבת</span>
      </Button>
      <Button
        variant="save"
        className={`${classes.action} ${classes.takeAway}`}
        disabled={isOpening}
        onClick={onTakeAway}
        dataTestId="kiosk-order-take-away"
      >
        <FontAwesomeIcon icon={faBagShopping as IconProp} className={classes.icon} />
        <span>לקחת</span>
      </Button>
    </div>
  </section>
);
